import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import Keycloak from 'keycloak-js';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const keycloak = inject(Keycloak);

    return next(req).pipe(
        catchError((error: unknown) => {
            const err = error as { status?: number };

            if (err?.status === 401) {
                // Only re-authenticate when the token is actually missing or expired.
                //
                // If we still hold a valid (non-expired) token and the server STILL
                // returns 401, the server is rejecting an otherwise-good token
                // (issuer/audience/clock-skew/signing-key mismatch). Calling
                // keycloak.login() in that case redirects to Keycloak, the live SSO
                // session immediately returns a fresh token, the request retries, gets
                // 401 again — an infinite reload loop. So surface the error instead.
                if (!keycloak.authenticated || keycloak.isTokenExpired()) {
                    keycloak.login();
                }
            }
            // 403 (Forbidden) is NOT redirected — let the calling service handle it
            // via error toasts or ProblemDetails display

            return throwError(() => error as unknown);
        })
    );
};
